/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Created.ai API
 * OpenAPI spec version: 1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AppearanceView,
  CaseResult,
  ErrorEnvelope,
  Preference,
  PreferenceUpdate,
  TeamSetting,
  TeamSettingUpdate
} from '../../model';

import { apiRequest } from '../../../client';
import type { ErrorType } from '../../../client';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getUpdateMyAppearanceUrl = () => {




  return `/api/v1/me/appearance`
}

/**
 * Save the person's theme (409 `THEME_LOCKED` for one not theirs) or their own switch.
 * @summary Update My Appearance
 */
export const updateMyAppearance = async (preferenceUpdate: PreferenceUpdate, options?: Parameters<typeof apiRequest>[1]): Promise<Preference> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<Preference>(getUpdateMyAppearanceUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(preferenceUpdate)
  }
);}





export const getUpdateMyAppearanceMutationKey = () => ['updateMyAppearance'] as const;

export const getUpdateMyAppearanceMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMyAppearance>>, TError,UpdateMyAppearanceMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof updateMyAppearance>>, TError,UpdateMyAppearanceMutationVariables, TContext> => {

const mutationKey = getUpdateMyAppearanceMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateMyAppearance>>, UpdateMyAppearanceMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateMyAppearance(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateMyAppearanceMutationResult = NonNullable<Awaited<ReturnType<typeof updateMyAppearance>>>
    export type UpdateMyAppearanceMutationBody = PreferenceUpdate
    export type UpdateMyAppearanceMutationError = ErrorType<ErrorEnvelope>
    export type UpdateMyAppearanceMutationVariables = {data: PreferenceUpdate}

    /**
 * @summary Update My Appearance
 */
export const useUpdateMyAppearance = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMyAppearance>>, TError,UpdateMyAppearanceMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateMyAppearance>>,
        TError,
        UpdateMyAppearanceMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateMyAppearanceMutationOptions(options), queryClient);
    }
    export const getGetAppearanceUrl = (teamId: string,) => {




  return `/api/v1/teams/${teamId}/appearance`
}

/**
 * Everything a page load needs: the person's theme and own switch, the team's switch,
 * each theme with its rarity and whether it is theirs, and today's case.
 * @summary Get Appearance
 */
export const getAppearance = async (teamId: string, options?: Parameters<typeof apiRequest>[1]): Promise<AppearanceView> => {

  return apiRequest<AppearanceView>(getGetAppearanceUrl(teamId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAppearanceQueryKey = (teamId: string,) => {
    return [
    `/api/v1/teams/${teamId}/appearance`
    ] as const;
    }


export const getGetAppearanceQueryOptions = <TData = Awaited<ReturnType<typeof getAppearance>>, TError = ErrorType<ErrorEnvelope>>(teamId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppearance>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAppearanceQueryKey(teamId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAppearance>>> = ({ signal }) => getAppearance(teamId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAppearance>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAppearanceQueryResult = NonNullable<Awaited<ReturnType<typeof getAppearance>>>
export type GetAppearanceQueryError = ErrorType<ErrorEnvelope>


export function useGetAppearance<TData = Awaited<ReturnType<typeof getAppearance>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppearance>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAppearance>>,
          TError,
          Awaited<ReturnType<typeof getAppearance>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAppearance<TData = Awaited<ReturnType<typeof getAppearance>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppearance>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAppearance>>,
          TError,
          Awaited<ReturnType<typeof getAppearance>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAppearance<TData = Awaited<ReturnType<typeof getAppearance>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppearance>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Appearance
 */

export function useGetAppearance<TData = Awaited<ReturnType<typeof getAppearance>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAppearance>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAppearanceQueryOptions(teamId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getOpenDailyCaseUrl = (teamId: string,) => {




  return `/api/v1/teams/${teamId}/appearance/case/open`
}

/**
 * Open the person's free case of today: a theme they lack, or rarely the jackpot,
 * credits for this team. Every open that day, in any of their teams, answers the same case.
 * From the person's session only (403 `FORBIDDEN` for a token); 409 `CASES_HIDDEN` when
 * the person or the team hid the cases; 409 `ALL_THEMES_OWNED` when every theme is theirs.
 * @summary Open Daily Case
 */
export const openDailyCase = async (teamId: string, options?: Parameters<typeof apiRequest>[1]): Promise<CaseResult> => {

  return apiRequest<CaseResult>(getOpenDailyCaseUrl(teamId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getOpenDailyCaseMutationKey = () => ['openDailyCase'] as const;

export const getOpenDailyCaseMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof openDailyCase>>, TError,OpenDailyCaseMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof openDailyCase>>, TError,OpenDailyCaseMutationVariables, TContext> => {

const mutationKey = getOpenDailyCaseMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof openDailyCase>>, OpenDailyCaseMutationVariables> = (props) => {
          const {teamId} = props ?? {};

          return  openDailyCase(teamId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OpenDailyCaseMutationResult = NonNullable<Awaited<ReturnType<typeof openDailyCase>>>

    export type OpenDailyCaseMutationError = ErrorType<ErrorEnvelope>
    export type OpenDailyCaseMutationVariables = {teamId: string}

    /**
 * @summary Open Daily Case
 */
export const useOpenDailyCase = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof openDailyCase>>, TError,OpenDailyCaseMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof openDailyCase>>,
        TError,
        OpenDailyCaseMutationVariables,
        TContext
      > => {
      return useMutation(getOpenDailyCaseMutationOptions(options), queryClient);
    }
    export const getUpdateTeamAppearanceUrl = (teamId: string,) => {




  return `/api/v1/teams/${teamId}/appearance/settings`
}

/**
 * Hide or show the free daily case for every member: the owner and admins only (403
 * `PERMISSION_DENIED`).
 * @summary Update Team Appearance
 */
export const updateTeamAppearance = async (teamId: string,
    teamSettingUpdate: TeamSettingUpdate, options?: Parameters<typeof apiRequest>[1]): Promise<TeamSetting> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<TeamSetting>(getUpdateTeamAppearanceUrl(teamId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(teamSettingUpdate)
  }
);}





export const getUpdateTeamAppearanceMutationKey = () => ['updateTeamAppearance'] as const;

export const getUpdateTeamAppearanceMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTeamAppearance>>, TError,UpdateTeamAppearanceMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof updateTeamAppearance>>, TError,UpdateTeamAppearanceMutationVariables, TContext> => {

const mutationKey = getUpdateTeamAppearanceMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTeamAppearance>>, UpdateTeamAppearanceMutationVariables> = (props) => {
          const {teamId,data} = props ?? {};

          return  updateTeamAppearance(teamId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateTeamAppearanceMutationResult = NonNullable<Awaited<ReturnType<typeof updateTeamAppearance>>>
    export type UpdateTeamAppearanceMutationBody = TeamSettingUpdate
    export type UpdateTeamAppearanceMutationError = ErrorType<ErrorEnvelope>
    export type UpdateTeamAppearanceMutationVariables = {teamId: string;data: TeamSettingUpdate}

    /**
 * @summary Update Team Appearance
 */
export const useUpdateTeamAppearance = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTeamAppearance>>, TError,UpdateTeamAppearanceMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateTeamAppearance>>,
        TError,
        UpdateTeamAppearanceMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateTeamAppearanceMutationOptions(options), queryClient);
    }
